import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)
import {
  syslogin,
  logout,
  selectUserInfo,
} from "@/api/login";
import {
  ajaxGetDictItems,
  getAlreadyAsp
} from "@/api/api";
export default new Vuex.Store({
  state: {
    token: "",
    userinfo: null,
    loginstate: false,
    userstate: false,
    memberstate: false,
    vip: false,
    membertype: 0,
    dictionary: [],
    emptyimg: 'https://chuyue-gaokao.oss-cn-hangzhou.aliyuncs.com/temp/noneimg_1681952454901.png',
    white_list: ['/homeindex', '/provincialControlLine', '/oneScoreOneSegment', '/chooseSubject', '/schoolComparison', '/collegeInformation', '/sameScore', "/school", "/specialty", "/expert", "/appraisal", "/volunteer"],
    contrastList: [], //学校对比id数组
    selective: null,
    score: null,
    precedence: null,
    searchtext: "",
    volunteerSum: 0,
    bindingCard: false,
    undergraduateDegree:[],//本科专业数据
    juniorDegree:[],//专科专业数据
  },
  mutations: {
    //设置token
    settoken(state, data) {
      state.token = data
    },
    //设置用户信息
    setuserinfo(state, data) {
      state.userinfo = data
      console.log(state.userinfo, "用户的信息")
    },
    setVipState(state, data) {
      state.vip = data;
    },
    //设置字典缓存
    setdictionary(state, data) {
      state.dictionary = data;
    },
    //设置登录弹窗状态
    setloginstate(state, data) {
      state.loginstate = data;
    },
    //设置用户信息状态
    setuserstate(state, data) {
      state.userstate = data;
    },
    //设置购买vip窗口状态
    setmemberstate(state, data) {
      state.memberstate = data;
    },
    //设置绑定会员卡窗口状态
    setBindingCardState(state, data) {
      state.bindingCard = data;
    },
    //设置购买vip还是次数
    setmembertype(state, data) {
      state.membertype = data;
    },

    //设置对比数组
    setcontrastList(state, data) {
      state.contrastList = data;
    },
    //设置选科
    setSelective(state, data) {
      state.selective = data;
    },
    //设置分数
    setScore(state, data) {
      state.score = data;
    },
    //设置位次
    setPrecedence(state, data) {
      state.precedence = data;
    },
    //设置搜索词
    setsearchtext(state, data) {
      state.searchtext = data;
    },
    //设置已填志愿数量
    setvolunteerSum(state, data) {
      state.volunteerSum = data;
    },
    // 设置本科专业数据
    setUndergraduateDegree(state, data) {
      state.undergraduateDegree = data;
    },
    //设置专科专业数据
    setJuniorDegree(state, data) {
      state.juniorDegree = data;
    },
  },
  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        syslogin(userInfo).then(res => {
          if (res.success) {
            const result = res.result
            commit('settoken', result.token)
            commit('setloginstate', false)
            commit('setuserinfo', result.userInfo)
            commit('setdictionary', result.sysAllDictItems)
            if (result.userInfo.examType === '1'||result.userInfo.examType==='4') {
              commit('setScore', result.userInfo.score);
              commit('setPrecedence', result.userInfo.rank);
            } else if (result.userInfo.examType === '2') {
              commit('setScore', result.userInfo.auditionTotalScore);
              commit('setPrecedence', result.userInfo.auditionTotalRank);
            } else if (result.userInfo.examType === '3') {
              commit('setScore', result.userInfo.peTotalScore);
              commit('setPrecedence', result.userInfo.peTotalRank);
            }

            Vue.ls.set('token', result.token, 1000 * 60 * 60 * 24 * 30)
            if (result.userInfo.score == null || result.userInfo.selectedSubjectValue == null) {
              commit('setuserstate', true)
            }
            // location.reload()
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出
    loginout({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(res => {
          if (res.success) {
            commit('settoken', null)
            commit('setuserinfo', null)
            commit('setloginstate', true)
            commit('setSelective', null)
            commit('setScore', null)
            commit('setPrecedence', null)
            Vue.ls.remove('token')
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })

    },
    //获取用户信息
    selectUserInfo({
      commit,
      state
    }) {
      // console.log(state);
      return new Promise((resolve, reject) => {
        selectUserInfo({
          id: state.userinfo.id,
        }).then(response => {
          console.log(response);
          if (response.success) {
            commit('setuserinfo', response.result)
            if (response.result.examType === '1' || response.result.examType === '4') {
              commit('setScore', response.result.score);
              commit('setPrecedence', response.result.rank)
            } else if (response.result.examType === '2') {
              commit('setScore', response.result.auditionTotalScore);
              commit('setPrecedence', response.result.auditionTotalRank)
            } else if (response.result.examType === '3') {
              commit('setScore', response.result.peTotalScore);
              commit('setPrecedence', response.result.peTotalRank);
            }
          }
          resolve(response)
        })
      })
    },
    //获取已填志愿数量
    getAlreadyAsp({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        if (!state.userinfo) {
          commit('setvolunteerSum', 0)
          return false
        }
        getAlreadyAsp({
          userId: state.userinfo.id,
        }).then(response => {
          if (response.success) {
            commit('setvolunteerSum', response.result)
          }
          resolve(response)
        })
      })
    },
    //更新选科
    updateSelective({
      commit,
      state
    }) {
      // console.log(state);
      return new Promise((resolve, reject) => {
        let code = [];
        console.log(state.selective);
        if (state.selective !== undefined) {
          code = state.selective.toString().split(",");
        }
        console.log(code);
        let arr = "";
        ajaxGetDictItems("choice_subject").then((res) => {
          if (res.success) {
            let choiceSubject = res.result;
            choiceSubject.forEach((item) => {
              if (
                code[0] == item.value ||
                code[1] == item.value ||
                code[2] == item.value
              ) {
                arr += item.description;
              }
            });
            commit('setSelective', arr.toString(" "))
          }
          resolve(res)
        });
      })
    },


  },
  modules: {},
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      paths: ["token", "userinfo", "dictionary", 'contrastList']
    })
  ],
})